import { EventHubAnalyticsProviderPlugin } from './eventHub.esm.js';

const plugins = [
    new EventHubAnalyticsProviderPlugin()
];

export { plugins };
